import { TruckSummary } from "../api/trucks/combineTrucks";

export class CombineTruckSummaryViewModel {
  id: number;
  name: string;
  driverName: string;
  Zip3sServiced: string;
  maxCubes: number;
  cubesUsed: number;
  availableCubes: number;
  selected: boolean;

  constructor(truck: TruckSummary) {
    this.id = truck.id;
    this.name = truck.name;
    this.driverName = truck.driverName;
    this.Zip3sServiced = truck.Zip3sServiced? truck.Zip3sServiced.join(', '): '';
    this.maxCubes = truck.maxCubes;
    this.cubesUsed = truck.cubesUsed;
    this.availableCubes = truck.availableCubes;
  }
}
